/**
 * @generated SignedSource<<886162fb131030e636963e819a221afa>>
 * @relayHash c891ebd5c4e792dc4af4918d6891c449
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b22bfa401eba72523cc9cc01584bfb2d1dff8561a7181892b569846aefed3bb

import type { ConcreteRequest } from 'relay-runtime';
export type AIPlannerSyncBylineQuery$variables = {
  cloudId: string;
  contentAri: string;
};
export type AIPlannerSyncBylineQuery$data = {
  readonly aiplanner_resolveArtifactByConfluenceContentAri: {
    readonly artifactUrl: string;
    readonly planTitle: string;
  } | null;
};
export type AIPlannerSyncBylineQuery = {
  response: AIPlannerSyncBylineQuery$data;
  variables: AIPlannerSyncBylineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentAri",
        "variableName": "contentAri"
      }
    ],
    "concreteType": "AiPlannerConfluenceArtifactByline",
    "kind": "LinkedField",
    "name": "aiplanner_resolveArtifactByConfluenceContentAri",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "planTitle"
      },
      {
        "kind": "ScalarField",
        "name": "artifactUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AIPlannerSyncBylineQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AIPlannerSyncBylineQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c891ebd5c4e792dc4af4918d6891c449",
    "id": "9b22bfa401eba72523cc9cc01584bfb2d1dff8561a7181892b569846aefed3bb",
    "metadata": {},
    "name": "AIPlannerSyncBylineQuery",
    "operationKind": "query",
    "text": "query AIPlannerSyncBylineQuery($cloudId:String!,$contentAri:String!){aiplanner_resolveArtifactByConfluenceContentAri(cloudId:$cloudId,contentAri:$contentAri){planTitle,artifactUrl}}"
  }
};
})();

(node as any).hash = "f6755a460763c0da6c43d2a9e189591a";

export default node;
